import React from "react";

import initialState from "./initial-state";
import reducer from "./reducer";
import MenuContext from "./context";

interface IProps {
  children: React.ReactNode;
}

const MenuProvider: React.FC<IProps> = ({ children }) => {
  const [menu, dispatch] = React.useReducer(reducer, initialState);

  return (
    <MenuContext.Provider value={{ menu, dispatch }}>
      {children}
    </MenuContext.Provider>
  );
};

export default MenuProvider;
